import { FC } from 'react';
import styled from 'styled-components';

import LocalizedLink from '@/components/LocalizedLink/LocalizedLink';
import { getImage } from '@/lib/fetchAPI';

const NavigationDropdown: FC<any> = ({ data }) => (
	<DropdownWrapper>
		<Shades />

		<Triangle alt="Icon" src="/images/icons/dropdown-triangle.png" />

		<Dropdown>
			{data?.map((item, index) => (
				<DropdownItem key={`dropdown_item_${index}`}>
					{item.image ? (
						<>
							<a target="_blank" rel="noopener noreferrer" href={item.link}>
								{item.name}
							</a>

							{item.image ? (
								<img alt={item?.name} src={getImage(item?.image)} />
							) : null}
						</>
					) : (
						<LocalizedLink href={item.link}>{item.name}</LocalizedLink>
					)}
				</DropdownItem>
			))}
		</Dropdown>
	</DropdownWrapper>
);

const Triangle = styled.img`
	position: absolute;
	top: 18px;
	left: 50%;
	transform: translateX(-50%);
	width: 20px;
	z-index: 9999;
`;

const DropdownWrapper = styled.div`
	position: absolute;
	width: 100%;
	top: -10px;
	left: 0;
`;

const Dropdown = styled.div`
	background-color: var(--color-white);
	padding: 15px 10px;
	width: 100%;
	margin-top: 32px;
	--smooth-corners: 14.34, 14.6;
	mask-image: paint(smooth-corners);
`;

const DropdownItem = styled.div`
	transition: 0.2s;
	font-family: var(--font-sans);

	font-size: 18px;
	line-height: 25px;
	color: var(--color-white);
	display: flex;
	align-items: center;
	--smooth-corners: 17.34, 4.6;
	mask-image: paint(smooth-corners);

	&:hover {
		background-color: var(--color-purple);

		a,
		div {
			color: var(--color-white) !important;
		}
	}

	img {
		width: 25px;
	}

	a,
	div {
		color: var(--color-purple) !important;
		transition: 0s !important;
		width: 100%;
		padding: 10px 15px;
	}
`;

const Shades = styled.div`
	&:after {
		content: '';
		position: absolute;
		width: 100%;
		height: 80%;
		top: 35px;
		left: 50%;
		transform: translateX(-50%);
		background-color: var(--color-blue);
		opacity: 0.07;
		filter: blur(32px);
		border-radius: 20px;
		z-index: -1;
	}

	&:before {
		content: '';
		position: absolute;
		width: 100%;
		height: calc(100% - 20px);
		top: 75px;
		left: 50%;
		transform: translateX(-50%) scale(0.8);
		background-color: var(--color-blue);
		opacity: 0.1;
		filter: blur(36px);
		border-radius: 20px;
		z-index: -1;
	}
`;

export default NavigationDropdown;
